import { Directive, ElementRef, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[rappiderResizable]'
})

export class ResizableDirective implements OnInit {


  @Input() resizableGrabWidth = 8;
  @Input() resizableMinWidth = 10;
  @Input() additionalLeftOffset?= 0;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onResize = new EventEmitter<any>();

  dragging = false;

  constructor(private el: ElementRef) {

    // const self = this;

    const EventListenerMode = { capture: true };

    function preventGlobalMouseEvents() {
      document.body.style['pointer-events'] = 'none';
    }

    function restoreGlobalMouseEvents() {
      document.body.style['pointer-events'] = 'auto';
    }


    const newWidth = (width) => {
      const newWidth = Math.max(this.resizableMinWidth, width);
      el.nativeElement.style.width = (newWidth) + 'px';
    };


    const mouseMoveG = (evt) => {
      if (!this.dragging) {
        return;
      }
      const mousePosition = evt.clientX - this.additionalLeftOffset;
      newWidth(mousePosition);
      evt.stopPropagation();
      this.onResize.emit({ width: mousePosition });
    };

    const mouseUpG = (evt) => {
      if (!this.dragging) {
        return;
      }
      // console.log('mouseUpG');
      this.setResizeHandlerStyleToDefault();
      restoreGlobalMouseEvents();
      this.dragging = false;
      evt.stopPropagation();
    };

    const mouseDown = (evt) => {
      if (this.inDragRegion(evt)) {
        this.dragging = true;

        // console.log('mouseDown');
        this.setResizeHandlerStyleToActive();

        preventGlobalMouseEvents();
        evt.stopPropagation();
      }
    };


    const mouseMove = (evt) => {
      // console.log(this.inDragRegion(evt), this.dragging);
      if (this.inDragRegion(evt) || this.dragging) {
        this.setResizeHandlerStyleToActive();
      }


    };

    const mouseOut = (evt) => {
      // console.log('mouseOut');
      if (!this.inDragRegion(evt) || !this.dragging) {
        this.setResizeHandlerStyleToDefault();
      }
    };


    document.addEventListener('mousemove', mouseMoveG, true);
    document.addEventListener('mouseup', mouseUpG, true);
    el.nativeElement.addEventListener('mousedown', mouseDown, true);
    el.nativeElement.addEventListener('mousemove', mouseMove, true);

    document.addEventListener('mouseleave', mouseOut, true);
  }

  ngOnInit(): void {
    // console.log('resizer init');
    this.setResizeHandlerStyleToDefault();
  }

  setResizeHandlerStyleToDefault() {
    this.el.nativeElement.classList.remove('dragging');
    this.el.nativeElement.style.cursor = 'default';
    this.el.nativeElement.style['border-right'] = this.resizableGrabWidth + 'px solid darkgrey';
  }

  setResizeHandlerStyleToActive() {
    this.el.nativeElement.classList.add('dragging');
    this.el.nativeElement.style.cursor = 'col-resize';
    this.el.nativeElement.style['border-right'] = this.resizableGrabWidth + 'px solid dodgerblue';
  }

  inDragRegion(evt) {
    return this.el.nativeElement.clientWidth - evt.clientX + this.el.nativeElement.offsetLeft < this.resizableGrabWidth;
  }

}
